import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/middlewares/auth.interceptor';
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';
import { ArchwizardModule } from 'angular-archwizard';
import { HelpModalComponent } from './help-modal/help-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPhotoEditorModule } from "ngx-photo-editor";
import { PublicModule } from './pages/public/public.module';
import { NotifyComponentComponent } from './notify-component/notify-component.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { HealthCheckComponent } from './health-check/health-check.component';
import { OpenedModule } from './pages/opened/opened.module';
import { MsalService, MSAL_CONFIG, MSAL_CONFIG_ANGULAR, BroadcastService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { ConfirmationModalReportComponent } from './confirmation-modal-report/confirmation-modal-report.component';
import { ReportDeletionLogModalComponent } from './report-deletion-log-modal/report-deletion-log-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    HealthCheckComponent,
    HelpModalComponent,
    NotifyComponentComponent,
    ConfirmationModalReportComponent,
    ReportDeletionLogModalComponent
  ],
  imports: [
    BrowserModule,
    NgxPaginationModule,
    AppRoutingModule,
    PublicModule,
    HttpClientModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    ArchwizardModule,
    NgbModule,
    NgxPhotoEditorModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    BsDropdownModule.forRoot(),
    CommonModule,
    OpenedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    BroadcastService,
    {
      provide: MSAL_CONFIG,
      useValue: {
        auth: {
          clientId: environment.azureAd.clientId,
          authority: environment.azureAd.authority,
          redirectUri: environment.azureAd.redirectUri
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: false
        }
      }
    },
    {
      provide: MSAL_CONFIG_ANGULAR,
      useValue: {
        popUp: true,
        consentScopes: environment.azureAd.scopes,
        unprotectedResources: [],
        protectedResourceMap: [
          ['https://graph.microsoft.com/v1.0/me', environment.azureAd.scopes]
        ]
      }
    },
    MsalService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
